<template>
  <div class="mobile-tabbar-container">
    <div class="content">
      <router-link :to="{path: '/'}" class="item">
        <div class="icon img-cover">
          <img v-if="tabBarKey == 'home'" src="../assets/images/tabbar/home-active-icon.png" />
          <img v-else src="../assets/images/tabbar/home-icon.png" />
        </div>
        <div class="name">首页</div>
      </router-link>
      <router-link :to="{path: '/class'}" class="item">
        <div class="icon img-cover">
          <img v-if="tabBarKey == 'class'" src="../assets/images/tabbar/class-active-icon.png" />
          <img v-else src="../assets/images/tabbar/class-icon.png" />
        </div>
        <div class="name">分类</div>
      </router-link>
      <router-link :to="{path: '/order'}" class="item">
        <div class="icon img-cover">
          <img v-if="tabBarKey == 'order'" src="../assets/images/tabbar/order-active-icon.png" />
          <img v-else src="../assets/images/tabbar/order-icon.png" />
        </div>
        <div class="name">订单</div>
      </router-link>
      <router-link :to="{path: '/news'}" class="item">
        <div class="icon img-cover">
          <img v-if="tabBarKey == 'news'" src="../assets/images/tabbar/news-active-icon.png" />
          <img v-else src="../assets/images/tabbar/news-icon.png" />
        </div>
        <div class="name">消息</div>
      </router-link>
      <router-link :to="{path: '/user'}" class="item">
        <div class="icon img-cover">
          <img v-if="tabBarKey == 'user'" src="../assets/images/tabbar/user-active-icon.png" />
          <img v-else src="../assets/images/tabbar/user-icon.png" />
        </div>
        <div class="name">我的</div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileTabBar',
  props: {
    tabBarKey: String
  }
}
</script>

<style scoped lang="less">
.mobile-tabbar-container {
  width: 100%;
  height: 1.04rem;
  .content {
    position: fixed;
    bottom: 0;
    width: var(--max-width);
    left: 50%;
    margin-left: var(---max-width-50);
    height: 1.04rem;
    padding: .12rem .3rem 0;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    box-shadow: 0px -4px 8px 2px rgba(0, 28, 84, .06);
    z-index: 999;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      width: .92rem;
      .icon {
        width: .48rem;
        height: .48rem;
      }
      .name {
        line-height: .3rem;
        color: #151d28;
        font-size: .2rem;
        font-weight: 500;
      }
    }
  }
}
</style>
